import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-outline-white.svg'


const _hoisted_1 = {
  id: "splashscreen",
  class: "center-all bg-primary"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SplashScreenComponent',
  emits: ["onAnimationFinished"],
  setup(__props, { emit: __emit }) {

const emit = __emit
setTimeout(() => {
    emit('onAnimationFinished')
}, 3500);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      class: "text-center",
      id: "splash-logo"
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        width: "120px",
        alt: ""
      }),
      _createElementVNode("h1", { class: "text-white mt-3 display-4" }, "Greezon")
    ], -1)
  ])))
}
}

})